import {
  ICategoryAsset,
  ICategoryLiteAsset,
  ICategoryLiteWithChildsAsset,
} from "models/Assets/ICategoryAsset";

const defaultFields = [
  "id",
  "order",
  "icon",
  "reporting_name",
  "parent_id",
  "app_image_path",
  "url_limit_depth",
  "has_price"
];

const fields_ar = [
  ...defaultFields,
  "url_name_ar",
  "label_ar",
  "label_en",
];

const fields_en = [
  ...defaultFields,
  "url_name_en",
  "label_en",
  "label_ar",
];

export const toLiteCategory =
  (lang) =>
  (category: ICategoryAsset): ICategoryLiteAsset => {
    if (!category) return null;
    const object = {};
    (lang === "en" ? fields_en : fields_ar).forEach((field) => {
      object[field] = category[field] ?? null;
    });
    return object as ICategoryLiteAsset;
  };

export const toLiteCatWithChilds = (
  category: ICategoryAsset,
  lang
): ICategoryLiteWithChildsAsset => {
  const { subCategories } = category;
  return {
    ...toLiteCategory(lang)(category),
    subCategories: subCategories.map(toLiteCategory(lang)),
  };
};

export const toLiteCatsWithChilds =
  (lang) =>
  (categories: ICategoryAsset[]): ICategoryLiteWithChildsAsset[] => {
    return categories.map((cat) => toLiteCatWithChilds(cat, lang));
  };

export const toLiteCategories =
  (lang) =>
  (categories: ICategoryAsset[]): ICategoryLiteAsset[] => {
    return categories.map(toLiteCategory(lang));
  };
